/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseFilePageBlock
 */
export interface DatabaseFilePageBlock extends DatabasePageBlock {
    /**
     * Contains the ID of a library file
     * @type {string}
     * @memberof DatabaseFilePageBlock
     */
    content?: string;
}

/**
 * Check if a given object implements the DatabaseFilePageBlock interface.
 */
export function instanceOfDatabaseFilePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFilePageBlockFromJSON(json: any): DatabaseFilePageBlock {
    return DatabaseFilePageBlockFromJSONTyped(json, false);
}

export function DatabaseFilePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFilePageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : json['content'],
    };
}

export function DatabaseFilePageBlockToJSON(value?: DatabaseFilePageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'content': value.content,
    };
}

